import React from "react";
import EducationalBookletModalState, { EducationalBookletModalProps } from "./EducationalBookletModal.models";
import './EducationalBookletModal.scss';
import BookletsService from "../../../services/education/BookletsService";
import { Modal } from "react-bootstrap";
import { BookletType } from "../../../models/interfaces/education/BookletType";
import { toast } from "react-toastify";
import { BookLetsEditionView } from "../../../models/views/education/BookLetsEditionView";
import VideoThumbnails from "../../shared/react-thumbnail/thumbnail";

export default class EducationalBookletModal extends React.PureComponent<EducationalBookletModalProps, EducationalBookletModalState> {
    bookletsService: BookletsService;
    constructor(props: any) {
        super(props);
        this.bookletsService = new BookletsService();
        this.state = {
            booklet: {},
            showVideo: false
        };
    }

    componentDidMount() {
        this.getById();
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.id !== this.props.id)
            this.getById();
    }

    getById = () => {
        let self = this;
        let bookletsService = self.bookletsService;

        if (self.props.id !== null && self.props.id !== undefined)
            bookletsService.getById(self.props.id).then(function (response) {
                self.setState({ booklet: response });
            });
    }

    createBookMark = () => {
        this.bookletsService.createBookMark(this.props.id as number).then(response => {
            toast.success("با موفقیت نشانه گزاری شد.");
            this.getById();
        }).catch(error => {
            toast.error("خطا در نشانه گزاری جزوه.");
        });
    }

    deleteBookMark = () => {
        this.bookletsService.deleteBookMark(this.props.id as number).then(response => {
            toast.success("با موفقیت از موارد نشان شده حذف شد.");
            this.getById();
        }).catch(error => {
            toast.error("خطا در حذف نشانه گزاری جزوه.");
        });
    }

    closeModal = () => {
        this.setState({ showVideo: false });
        this.props.closeModal();
    }

    render(): React.ReactNode {
        let { showModal, closeModal } = this.props;
        let { booklet } = this.state;

        let file;
        if (booklet.bookletType === BookletType.File) {
            if (booklet.fileContentType?.includes("video"))
                file = (<>{this.videoView(booklet)}</>)
            else if (booklet.fileContentType?.includes("audio"))
                file = (<>{this.audioView(booklet)}</>)
            else
                file = (<>{this.nonVideoView(booklet)}</>)
        }
        else file = (<></>);

        ;
        return (<>

            <Modal show={showModal} onHide={this.closeModal} animation={true}>
                <Modal.Header >
                    <Modal.Title>
                        <label>مشاهده جزوه</label>

                        <div className="EducationBookletModalArea icon-area">
                            {
                                booklet.hasBookMarked === true ?
                                    <label className="mdi mdi-bookmark" onClick={this.deleteBookMark}></label>
                                    :
                                    <label className="mdi mdi-bookmark-outline" onClick={this.createBookMark}></label>
                            }
                        </div>

                    </Modal.Title>
                </Modal.Header>

                <Modal.Body >
                    <div className="col-12">
                        <label>عنوان : </label>
                        <label style={{ fontSize: "14px" }}>({booklet.title})</label>
                        <div>
                            <label style={{ display: "block" }}>متن : </label>
                            <label style={{ fontSize: "14px" }}>{booklet.description}</label>
                        </div>
                    </div>
                    {file}
                </Modal.Body >

                <Modal.Footer dir="ltr">
                    <button className="btn btn btn-primary tk-float-left" onClick={this.closeModal}>بستن</button>
                </Modal.Footer>
            </Modal >
        </>);
    }

    nonVideoView(booklet: BookLetsEditionView) {
        return <>
            <div className="col-12 tk-padding-top">
                <div className="tk-card" style={{ height: "70px" }}>
                    <div className="col-12">
                        <div className="row tk-padding-top">
                            <div className="col-5 notspace" style={{ textAlign: "left" }}>
                                <label style={{ color: "#6cb4ff", paddingLeft: "10px", fontSize: "25px" }} className="mdi mdi-file-document"></label>
                            </div>
                            <div className="col-7 notspace">
                                <a href={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet.fileAttachmentId}`} target="_blank" rel="noreferrer" style={{ paddingTop: "8px" }}>دانلود فایل</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    }

    videoView(booklet: BookLetsEditionView) {
        let content;
        if (this.state.showVideo) {
            content = <>
                {
                    <video style={{ width: "100%" }} height="185" controls>
                        <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet.fileAttachmentId}`} type="video/webm" />
                        <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet.fileAttachmentId}`} type="video/ogg" />
                        <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet.fileAttachmentId}`} type="video/mp4" />
                    </video>
                }
            </>
        }
        else
            content = <>
                <VideoThumbnails width={620} height={844} videoUrl={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet.fileAttachmentId}`} />
                <i className="play-icon mdi mdi-play-circle-outline"></i>
            </>;

        return <>
            <div className="EducationBookletModalArea video-contet" onClick={() => this.setState({ showVideo: true })}>
                {content}
            </div>
        </>
    }

    audioView(booklet: BookLetsEditionView) {
        return <>
            <div style={{ textAlign: 'center' }}>
                {
                    <audio style={{ width: "100%" }} controls>
                        <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet.fileAttachmentId}`} type="video/wav" />
                        <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet.fileAttachmentId}`} type="video/ogg" />
                        <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet.fileAttachmentId}`} type="video/mpeg" />
                        Your browser does not support the audio element.
                    </audio>
                }
            </div>
        </>
    }

    imageView(booklet: BookLetsEditionView) {
        return <>
            <div style={{ textAlign: 'center' }}>
                {
                    <img src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${booklet.fileAttachmentId}`} alt="coaching image" />
                }
            </div>
        </>
    }
}